import { call, put, takeLatest } from 'redux-saga/effects';
import { appointmentService } from './appointment.service';
import {
    ADD_APPOINTMENT_LINK,
    ADD_EDIT_APPT_NOTE,
    APPEND_SIGNATURE_TO_APPMT,
    BULK_ASSIGN_SIGNATURE,
    APPOINTMENT_FROM_TEMPLATE,
    APPOINTMENT_REPEAT,
    CANCEL_APPT,
    CHANGE_APPOINTMENT_LOCK_UNLOCK,
    CHANGE_APPT_UNITS,
    CHANGE_CANCEL_REASON,
    CONNECT_RECONNECT_TEMPLATE,
    CREATE_APPOINTMENT,
    DELETE_ALL_APPT,
    DELETE_APPOINTMENT,
    DELETE_APPT_DOCUMENT,
    DELETE_APPT_NOTE,
    DELETE_SIGNATURE,
    EDIT_APPOINTMENT,
    EDIT_APPT_DOCUMENT,
    GET_APPOINTMENT,
    GET_APPOINTMENT_BY_FILTERS,
    GET_APPOINTMENT_BY_FILTERS_SUCCESS,
    GET_APPOINTMENT_BY_ID,
    GET_APPOINTMENT_BY_ID_SUCCESS,
    GET_APPOINTMENT_DATES_BY_ID,
    GET_APPOINTMENT_DATES_BY_ID_SUCCESS,
    GET_APPOINTMENT_INFORMATION,
    GET_APPOINTMENT_INFORMATION_SUCCESS,
    GET_APPT_ADDRESSES,
    GET_APPT_ADDRESSES_SUCCESS,
    GET_ELIGIBLE_CHARGE_RATES,
    GET_ELIGIBLE_CHARGE_RATES_SUCCESS,
    GET_APPOINTMENT_SUCCESS,
    GET_APPT_DOCUMENT,
    GET_APPT_DOCUMENT_SUCCESS,
    GET_APPT_STAFFS,
    GET_APPT_STAFFS_SUCCESS,
    GET_CLIENT_STAFFS,
    GET_CLIENT_STAFFS_SUCCESS,
    MANAGE_NOTES,
    REFRESH_ERRORS,
    REMOVE_APPT_FROM_BILL,
    REMOVE_APPT_FROM_INVOICE,
    SET_APPOINTMENT_STATUS,
    UN_RENDER_APPT,
    UPLOAD_APPT_DOCUMENT,
    DELETE_MASS_APPTS,
    REQUEST_APPT_NOTE,
    REMIND_APPT_NOTE,
    COMPLETE_MASS_APPTS,
    COMPLETE_MASS_APPTS_SUCCESS,
    CHECK_ELIGIBILITY,
    UN_CANCEL_APPT,
    MULTI_STAFF_OVERLAPPING,
    GET_APPT_DATA_COLLECTION,
    GET_APPT_DATA_COLLECTION_SUCCESS,
    GET_APPOINTMENT_FOR_CALENDAR,
    GET_APPOINTMENT_FOR_CALENDAR_SUCCESS,
    REMIND_APPT_SIGNATURE,
} from './appointment.type';
import { httpRequestsOnErrorsActions } from '../http_requests_on_errors';
import { httpRequestsOnLoadActions } from '../http_requests_on_load';
import { httpRequestsOnSuccessActions } from '../http_requests_on_success';
import { toast } from 'react-toastify';
import { NotError } from '../../components';
import React from 'react';
import { PermissionList, RolePermission } from '../../utils';

/** Create, Edit Appointment */

export function* getAppointmentWithSessionIfAllowed(appointmentId) {
    const res = yield call(appointmentService.getAppointmentByIdService, appointmentId);
    let apptSessionData = null;

    if (res?.data?.csessionStatus && RolePermission([PermissionList.GOAL_READ?.code])) {
        try {
            const apptSession = yield call(appointmentService.getAppointmentSessionService, appointmentId);
            apptSessionData = apptSession?.data || null;
        } catch (err) {
            apptSessionData = null;
        }
    }

    return {
        ...res.data,
        ...(apptSessionData ? { cSession: apptSessionData } : {}),
    };
}

function* createAppointmentSaga(action) {
    yield put(httpRequestsOnErrorsActions.removeError(action.type));
    yield put(httpRequestsOnLoadActions.appendLoading(action.type));
    yield put(httpRequestsOnSuccessActions.removeSuccess(action.type));
    yield put(httpRequestsOnSuccessActions.removeSuccess(MULTI_STAFF_OVERLAPPING));
    yield put(httpRequestsOnSuccessActions.removeSuccess('RENDER_APPOINTMENTS_LIST'));
    try {
        const res = yield call(appointmentService.createAppointmentService, action?.payload?.body);
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));

        if (res?.data?.message === 'Staff overlap on appointment') {
            yield put(httpRequestsOnSuccessActions.appendSuccess(MULTI_STAFF_OVERLAPPING, res?.data));
        } else {
            yield put(httpRequestsOnSuccessActions.appendSuccess(action.type));
            yield put(httpRequestsOnSuccessActions.appendSuccess('RENDER_APPOINTMENTS_LIST'));
        }

        if (res.data?.id || res.data?._id) {
            yield put({
                type: GET_APPOINTMENT_BY_ID,
                payload: { id: res.data?.id || res.data?._id },
            });
        }
    } catch (err) {
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put(httpRequestsOnErrorsActions.appendError(action.type, err?.data?.message));
    }
}

function* editAppointmentSaga(action) {
    yield put(httpRequestsOnErrorsActions.removeError(action.type));
    yield put(httpRequestsOnLoadActions.appendLoading(action.type));
    yield put(httpRequestsOnSuccessActions.removeSuccess(action.type));
    yield put(httpRequestsOnSuccessActions.removeSuccess('RENDER_APPOINTMENTS_LIST'));
    try {
        yield call(appointmentService.editAppointmentService, action?.payload?.body, action?.payload?.id);
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put(httpRequestsOnSuccessActions.appendSuccess(action.type));
        yield put(httpRequestsOnSuccessActions.appendSuccess('RENDER_APPOINTMENTS_LIST'));

        if (action?.payload?.id) {
            const data = yield call(getAppointmentWithSessionIfAllowed, action?.payload?.id);
            yield put({
                type: GET_APPOINTMENT_BY_ID_SUCCESS,
                payload: data,
            });

            // const res = yield call(appointmentService.getAppointmentByIdService, action?.payload?.id);
            // yield put(httpRequestsOnLoadActions.removeLoading(action.type));
            // yield put({
            //     type: GET_APPOINTMENT_BY_ID_SUCCESS,
            //     payload: res.data,
            // });
        }
    } catch (err) {
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put(httpRequestsOnErrorsActions.appendError(action.type, err?.data?.message));
    }
}

function* addAppointmentLink(action) {
    yield put(httpRequestsOnErrorsActions.removeError(action.type));
    yield put(httpRequestsOnLoadActions.appendLoading(action.type));
    yield put(httpRequestsOnSuccessActions.removeSuccess(action.type));
    try {
        yield call(appointmentService.addAppointmentLinkService, action?.payload?.body, action?.payload?.id);

        const data = yield call(getAppointmentWithSessionIfAllowed, action?.payload?.id);
        yield put({
            type: GET_APPOINTMENT_BY_ID_SUCCESS,
            payload: data,
        });

        // const res = yield call(appointmentService.getAppointmentByIdService, action?.payload?.id);
        // yield put({
        //     type: GET_APPOINTMENT_BY_ID_SUCCESS,
        //     payload: res.data,
        // });
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put(httpRequestsOnSuccessActions.appendSuccess(action.type));
    } catch (err) {
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put(httpRequestsOnErrorsActions.appendError(action.type, err?.data?.message));
    }
}

function* editApptLockUnlock(action) {
    yield put(httpRequestsOnErrorsActions.removeError(action.type));
    yield put(httpRequestsOnLoadActions.appendLoading(action.type));
    yield put(httpRequestsOnSuccessActions.removeSuccess(action.type));
    yield put(httpRequestsOnSuccessActions.removeSuccess('RENDER_APPOINTMENTS_LIST'));
    try {
        yield call(appointmentService.editApptLockUnlockService, action?.payload);
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put(httpRequestsOnSuccessActions.appendSuccess(action.type));
        yield put(httpRequestsOnSuccessActions.appendSuccess('RENDER_APPOINTMENTS_LIST'));

        if (action?.payload?.apptId) {
            const data = yield call(getAppointmentWithSessionIfAllowed, action?.payload?.apptId);
            yield put({
                type: GET_APPOINTMENT_BY_ID_SUCCESS,
                payload: data,
            });

            // const res = yield call(appointmentService.getAppointmentByIdService, action?.payload?.apptId);
            // yield put(httpRequestsOnLoadActions.removeLoading(action.type));
            // yield put({
            //     type: GET_APPOINTMENT_BY_ID_SUCCESS,
            //     payload: res.data,
            // });
        }
    } catch (err) {
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put(httpRequestsOnSuccessActions.removeSuccess(action.type));
        // yield put(httpRequestsOnErrorsActions.appendError('APPOINTMENT_OVERLAPPING_TOASTER', err?.data?.message));
        // yield put(httpRequestsOnErrorsActions.appendError('APPOINTMENT_OVERLAPPING', err?.data?.message));
    }
}
function* changeApptUnits(action) {
    yield put(httpRequestsOnErrorsActions.removeError(action.type));
    yield put(httpRequestsOnLoadActions.appendLoading(action.type));
    yield put(httpRequestsOnSuccessActions.removeSuccess(action.type));
    yield put(httpRequestsOnSuccessActions.removeSuccess('RENDER_APPOINTMENTS_LIST'));
    try {
        yield call(appointmentService.changeApptUnitsService, action?.payload);
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put(httpRequestsOnSuccessActions.appendSuccess(action.type));
        yield put(httpRequestsOnSuccessActions.appendSuccess('RENDER_APPOINTMENTS_LIST'));

        if (action?.payload?.apptId) {
            const data = yield call(getAppointmentWithSessionIfAllowed, action?.payload?.apptId);
            yield put({
                type: GET_APPOINTMENT_BY_ID_SUCCESS,
                payload: data,
            });

            // const res = yield call(appointmentService.getAppointmentByIdService, action?.payload?.apptId);
            // yield put(httpRequestsOnLoadActions.removeLoading(action.type));
            // yield put({
            //     type: GET_APPOINTMENT_BY_ID_SUCCESS,
            //     payload: res.data,
            // });
        }
    } catch (err) {
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put(httpRequestsOnSuccessActions.removeSuccess(action.type));
    }
}

/** end */

/** Get Appointment */
function* getAppointmentSaga(action) {
    if (action.payload?.load !== 'noLoad') {
        yield put(httpRequestsOnLoadActions.appendLoading(action.type));
    }
    yield put(httpRequestsOnErrorsActions.removeError(action.type));
    try {
        const res = yield call(appointmentService.getAppointmentService, action?.payload?.params);
        yield put({
            type: GET_APPOINTMENT_SUCCESS,
            payload: res.data,
        });
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
    } catch (err) {
        yield put({
            type: GET_APPOINTMENT_SUCCESS,
            payload: [],
        });
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        if (err?.data?.message === 'Internal server error') {
            yield put(httpRequestsOnErrorsActions.appendError(action.type, err?.data?.message));
        }
    }
}
function* getCalendarAppointmentSaga(action) {
    yield put(httpRequestsOnLoadActions.appendLoading(action.type));
    yield put(httpRequestsOnErrorsActions.removeError(action.type));
    try {
        const res = yield call(appointmentService.getCalendarAppointmentService, action?.payload?.params);
        yield put({
            type: GET_APPOINTMENT_FOR_CALENDAR_SUCCESS,
            payload: res.data,
        });
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
    } catch (err) {
        yield put({
            type: GET_APPOINTMENT_FOR_CALENDAR_SUCCESS,
            payload: [],
        });
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        if (err?.data?.message === 'Internal server error') {
            yield put(httpRequestsOnErrorsActions.appendError(action.type, err?.data?.message));
        }
    }
}

function* getAppointmentByIdSaga(action) {
    if (action?.payload?.load !== 'noLoad') {
        yield put(httpRequestsOnLoadActions.appendLoading(action.type));
    }
    yield put(httpRequestsOnErrorsActions.removeError(action.type));

    try {
        const data = yield call(getAppointmentWithSessionIfAllowed, action?.payload?.id);
        yield put({
            type: GET_APPOINTMENT_BY_ID_SUCCESS,
            payload: data,
        });

        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        //
        // yield put({
        //     type: GET_APPOINTMENT_BY_ID_SUCCESS,
        //     payload: data,
        // });
    } catch (err) {
        yield put({
            type: GET_APPOINTMENT_BY_ID_SUCCESS,
            payload: {},
        });
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        if (err?.data?.message === 'Internal server error') {
            yield put(httpRequestsOnErrorsActions.appendError(action.type, err?.data?.message));
        }
    }
}

function* getAppointmentDatesByIdSaga(action) {
    yield put(httpRequestsOnLoadActions.appendLoading(action.type));
    yield put(httpRequestsOnErrorsActions.removeError(action.type));
    try {
        const res = yield call(appointmentService.getAppointmentDatesByIdService, action?.payload?.id);
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put({
            type: GET_APPOINTMENT_DATES_BY_ID_SUCCESS,
            payload: res.data,
        });
    } catch (err) {
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        if (err?.data?.message === 'Internal server error') {
            yield put(httpRequestsOnErrorsActions.appendError(action.type, err?.data?.message));
        }
    }
}

function* getAppointmentInformation(action) {
    yield put(httpRequestsOnErrorsActions.removeError(action.type));
    yield put(httpRequestsOnLoadActions.appendLoading(action.type));
    try {
        const res = yield call(appointmentService.getAppointmentInformationService, action?.payload?.id);
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put({
            type: GET_APPOINTMENT_INFORMATION_SUCCESS,
            payload: res.data,
        });
    } catch (err) {
        yield put({
            type: GET_APPOINTMENT_INFORMATION_SUCCESS,
            payload: null,
        });
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        if (err?.data?.message === 'Internal server error') {
            yield put(httpRequestsOnErrorsActions.appendError(action.type, err?.data?.message));
        }
    }
}

function* getApptAddresses(action) {
    yield put(httpRequestsOnErrorsActions.removeError(action.type));
    yield put(httpRequestsOnLoadActions.appendLoading(action.type));
    try {
        const res = yield call(
            appointmentService.getApptAddressesService,
            action?.payload?.clientId,
            action?.payload?.staffId,
        );
        yield put({
            type: GET_APPT_ADDRESSES_SUCCESS,
            payload: res.data,
        });
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
    } catch (err) {
        yield put({
            type: GET_APPT_ADDRESSES_SUCCESS,
            payload: null,
        });
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
    }
}

function* getEligibleChargeRates(action) {
    yield put(httpRequestsOnErrorsActions.removeError(action.type));
    yield put(httpRequestsOnLoadActions.appendLoading(action.type));
    try {
        const res = yield call(
            appointmentService.getEligibleChargeRatesService,
            action?.payload?.staffId,
            action?.payload?.authServiceId,
            action?.payload?.clientId,
        );
        yield put({
            type: GET_ELIGIBLE_CHARGE_RATES_SUCCESS,
            payload: res.data,
        });
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
    } catch (err) {
        yield put({
            type: GET_ELIGIBLE_CHARGE_RATES_SUCCESS,
            payload: [],
        });
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
    }
}

function* getAppointmentFilterSaga(action) {
    if(action?.payload?.load !== 'noLoad') {
        yield put(httpRequestsOnLoadActions.appendLoading(action.type));
    }
    yield put(httpRequestsOnErrorsActions.removeError(action.type));
    try {
        const res = yield call(appointmentService.getAppointmentService, action?.payload?.params);
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put({
            type: GET_APPOINTMENT_BY_FILTERS_SUCCESS,
            payload: res.data,
        });
    } catch (err) {
        yield put({
            type: GET_APPOINTMENT_BY_FILTERS_SUCCESS,
            payload: null,
        });
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        if (err?.data?.message === 'Internal server error') {
            yield put(httpRequestsOnErrorsActions.appendError(action.type, err?.data?.message));
        }
    }
}
function* getApptDataCollection(action) {
    yield put(httpRequestsOnLoadActions.appendLoading(action.type));
    yield put(httpRequestsOnErrorsActions.removeError(action.type));
    try {
        const res = yield call(appointmentService.getApptDataCollectionService, action?.payload?.sessionId);
        yield put({
            type: GET_APPT_DATA_COLLECTION_SUCCESS,
            payload: res.data,
        });
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
    } catch (err) {
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        if (err?.data?.message === 'Internal server error') {
            yield put(httpRequestsOnErrorsActions.appendError(action.type, err?.data?.message));
        }
    }
}

/** end */

/** Delete Appointment */
function* deleteAppointmentSaga(action) {
    yield put(httpRequestsOnErrorsActions.removeError(action.type));
    yield put(httpRequestsOnLoadActions.appendLoading(action.type));
    yield put(httpRequestsOnSuccessActions.removeSuccess(action.type));
    yield put(httpRequestsOnSuccessActions.removeSuccess('RENDER_APPOINTMENTS_LIST'));
    try {
        yield call(appointmentService.deleteAppointmentService, action.payload.id);
        // yield put({
        //     type: DELETE_APPOINTMENT_SUCCESS,
        //     payload: action.payload.id,
        // });
        yield put(httpRequestsOnSuccessActions.appendSuccess(action?.type));
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put(httpRequestsOnSuccessActions.appendSuccess('RENDER_APPOINTMENTS_LIST'));
        // yield put({ type: GET_APPOINTMENT, payload: { load: 'noLoad', params: action?.payload?.params } });
    } catch (err) {
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put(httpRequestsOnErrorsActions.appendError(action.type, err?.data?.message));
    }
}

function* deleteMassAppointment(action) {
    yield put(httpRequestsOnErrorsActions.removeError(action.type));
    yield put(httpRequestsOnLoadActions.appendLoading(action.type));
    yield put(httpRequestsOnSuccessActions.removeSuccess(action.type));
    yield put(httpRequestsOnSuccessActions.removeSuccess('RENDER_APPOINTMENTS_LIST'));
    try {
        yield call(appointmentService.deleteMassApptsService, action?.payload?.apptList, action?.payload?.params);
        yield put(httpRequestsOnSuccessActions.appendSuccess(action?.type));
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put(httpRequestsOnSuccessActions.appendSuccess('RENDER_APPOINTMENTS_LIST'));
    } catch (err) {
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put(httpRequestsOnErrorsActions.appendError(action.type, err?.data?.message));
    }
}

/** end */

/** Appointment Status */
function* setAppointmentStatusSaga(action) {
    const loaderType =
        action?.payload?.statusName === 'complete'
            ? 'SET_APPOINTMENT_STATUS_COMPLETE'
            : action?.payload?.statusName === 'render'
              ? 'SET_APPOINTMENT_STATUS_COMPLETE'
              : 'SET_APPOINTMENT_STATUS_CANCEL';
    yield put(httpRequestsOnLoadActions.appendLoading(loaderType));
    yield put(httpRequestsOnErrorsActions.removeError(action.type));
    yield put(httpRequestsOnSuccessActions.removeSuccess(action.type));
    yield put(httpRequestsOnSuccessActions.removeSuccess('RENDER_APPOINTMENTS_LIST'));
    try {
        yield call(
            appointmentService.setAppointmentStatusService,
            action?.payload?.id,
            action?.payload?.statusName,
            action?.payload?.reason
        );
        yield put(httpRequestsOnLoadActions.removeLoading(loaderType));
        yield put(httpRequestsOnSuccessActions.appendSuccess(action.type));
        yield put(httpRequestsOnSuccessActions.appendSuccess('RENDER_APPOINTMENTS_LIST'));
        if (action?.payload?.id) {
            const data = yield call(getAppointmentWithSessionIfAllowed, action?.payload?.id);
            yield put({
                type: GET_APPOINTMENT_BY_ID_SUCCESS,
                payload: data,
            });

            // const res = yield call(appointmentService.getAppointmentByIdService, action?.payload?.id);
            // yield put(httpRequestsOnLoadActions.removeLoading(action.type));
            // yield put({
            //     type: GET_APPOINTMENT_BY_ID_SUCCESS,
            //     payload: res.data,
            // });
        }
    } catch (err) {
        if (action?.payload?.id) {
            yield put(httpRequestsOnSuccessActions.appendSuccess('RENDER_APPOINTMENTS_CATCH_LIST'));

            const data = yield call(getAppointmentWithSessionIfAllowed, action?.payload?.id);
            yield put({
                type: GET_APPOINTMENT_BY_ID_SUCCESS,
                payload: data,
            });

            // const res = yield call(appointmentService.getAppointmentByIdService, action?.payload?.id);
            // yield put(httpRequestsOnLoadActions.removeLoading(action.type));
            // yield put({
            //     type: GET_APPOINTMENT_BY_ID_SUCCESS,
            //     payload: res.data,
            // });
        }
        yield put(httpRequestsOnLoadActions.removeLoading(loaderType));
        yield put(httpRequestsOnErrorsActions.appendError(action.type, err?.data?.message));
    }
}

function* removeApptFromBill(action) {
    yield put(httpRequestsOnLoadActions.appendLoading(action.type));
    yield put(httpRequestsOnSuccessActions.removeSuccess(action.type));
    yield put(httpRequestsOnSuccessActions.removeSuccess('RENDER_APPOINTMENTS_LIST'));
    try {
        yield call(appointmentService.removeApptFromBillService, action?.payload?.params);
        if (action?.payload?.id) {
            const data = yield call(getAppointmentWithSessionIfAllowed, action?.payload?.id);
            yield put({
                type: GET_APPOINTMENT_BY_ID_SUCCESS,
                payload: data,
            });
        }
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put(httpRequestsOnSuccessActions.appendSuccess(action.type));
        yield put(httpRequestsOnSuccessActions.appendSuccess('RENDER_APPOINTMENTS_LIST'));
    } catch (err) {
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put(httpRequestsOnErrorsActions.appendError(action.type, err?.data?.message));
    }
}

function* removeApptFromInvoice(action) {
    yield put(httpRequestsOnLoadActions.appendLoading(action.type));
    yield put(httpRequestsOnSuccessActions.removeSuccess(action.type));
    yield put(httpRequestsOnSuccessActions.removeSuccess('RENDER_APPOINTMENTS_LIST'));
    try {
        yield call(appointmentService.removeApptFromInvoiceService, action?.payload?.id, action?.payload?.params);
        if (action?.payload?.id) {
            const data = yield call(getAppointmentWithSessionIfAllowed, action?.payload?.id);
            yield put({
                type: GET_APPOINTMENT_BY_ID_SUCCESS,
                payload: data,
            });
        }
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put(httpRequestsOnSuccessActions.appendSuccess(action.type));
        yield put(httpRequestsOnSuccessActions.appendSuccess('RENDER_APPOINTMENTS_LIST'));
    } catch (err) {
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put(httpRequestsOnErrorsActions.appendError(action.type, err?.data?.message));
    }
}

function* unRenderAppt(action) {
    yield put(httpRequestsOnLoadActions.appendLoading(action.type));
    yield put(httpRequestsOnSuccessActions.removeSuccess(action.type));
    yield put(httpRequestsOnSuccessActions.removeSuccess('RENDER_APPOINTMENTS_LIST'));
    try {
        yield call(appointmentService.unRenderApptService, action?.payload?.id);
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put(httpRequestsOnSuccessActions.appendSuccess(action.type));
        yield put(httpRequestsOnSuccessActions.appendSuccess('RENDER_APPOINTMENTS_LIST'));
        if (action?.payload?.id) {
            const data = yield call(getAppointmentWithSessionIfAllowed, action?.payload?.id);
            yield put({
                type: GET_APPOINTMENT_BY_ID_SUCCESS,
                payload: data,
            });

            // const res = yield call(appointmentService.getAppointmentByIdService, action?.payload?.id);
            // yield put(httpRequestsOnLoadActions.removeLoading(action.type));
            // yield put({
            //     type: GET_APPOINTMENT_BY_ID_SUCCESS,
            //     payload: res.data,
            // });
        }
    } catch (err) {
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put(httpRequestsOnErrorsActions.appendError(action.type, err?.data?.message));
    }
}

function* changeCancelReason(action) {
    yield put(httpRequestsOnLoadActions.appendLoading(action.type));
    yield put(httpRequestsOnSuccessActions.removeSuccess(action.type));
    yield put(httpRequestsOnSuccessActions.removeSuccess('RENDER_APPOINTMENTS_LIST'));
    try {
        yield call(appointmentService.changeCancelReasonReason, action?.payload?.id, action?.payload?.reason);
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put(httpRequestsOnSuccessActions.appendSuccess(action.type));
        yield put(httpRequestsOnSuccessActions.appendSuccess('RENDER_APPOINTMENTS_LIST'));
        if (action?.payload?.id) {
            const data = yield call(getAppointmentWithSessionIfAllowed, action?.payload?.id);
            yield put({
                type: GET_APPOINTMENT_BY_ID_SUCCESS,
                payload: data,
            });

            // const res = yield call(appointmentService.getAppointmentByIdService, action?.payload?.id);
            // yield put(httpRequestsOnLoadActions.removeLoading(action.type));
            // yield put({
            //     type: GET_APPOINTMENT_BY_ID_SUCCESS,
            //     payload: res.data,
            // });
        }
    } catch (err) {
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put(httpRequestsOnErrorsActions.appendError(action.type, err?.data?.message));
    }
}

function* completeMassAppts(action) {
    yield put(httpRequestsOnLoadActions.appendLoading(action.type));
    yield put(httpRequestsOnSuccessActions.removeSuccess(action.type));
    yield put(httpRequestsOnSuccessActions.removeSuccess('RENDER_APPOINTMENTS_LIST'));
    try {
        const res = yield call(appointmentService.completeMassApptsService, action?.payload?.apptIds, action?.payload?.params);
        yield put({
            type: COMPLETE_MASS_APPTS_SUCCESS,
            payload: res.data,
        });
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put(httpRequestsOnSuccessActions.appendSuccess(action.type));
        yield put(httpRequestsOnSuccessActions.appendSuccess('RENDER_APPOINTMENTS_LIST'));
    } catch (err) {
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put(httpRequestsOnErrorsActions.appendError(action.type, err?.data?.message));
    }
}

/** end */

/** Appointment Repeat */
function* appointmentRepeatSaga(action) {
    yield put(httpRequestsOnLoadActions.appendLoading(action.type));
    yield put(httpRequestsOnErrorsActions.removeError(action.type));
    yield put(httpRequestsOnSuccessActions.removeSuccess(action.type));
    yield put(httpRequestsOnSuccessActions.removeSuccess('RENDER_APPOINTMENTS_LIST'));
    try {
        yield call(appointmentService.appointmentRepeatService, action.payload.body);
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put(httpRequestsOnSuccessActions.appendSuccess(action.type));
        yield put(httpRequestsOnSuccessActions.appendSuccess('RENDER_APPOINTMENTS_LIST'));
        if (action?.payload?.id) {
            const data = yield call(getAppointmentWithSessionIfAllowed, action?.payload?.id);
            yield put({
                type: GET_APPOINTMENT_BY_ID_SUCCESS,
                payload: data,
            });

            // const res = yield call(appointmentService.getAppointmentByIdService, action?.payload?.id);
            // yield put(httpRequestsOnLoadActions.removeLoading(action.type));
            // yield put({
            //     type: GET_APPOINTMENT_BY_ID_SUCCESS,
            //     payload: res.data,
            // });
        }
    } catch (err) {
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put(httpRequestsOnErrorsActions.appendError(action.type, err?.data?.message));
    }
}

function* appointmentFromTemplateSaga(action) {
    yield put(httpRequestsOnLoadActions.appendLoading(action.type));
    yield put(httpRequestsOnErrorsActions.removeError(action.type));
    yield put(httpRequestsOnSuccessActions.removeSuccess(action.type));
    yield put(httpRequestsOnSuccessActions.removeSuccess('RENDER_APPOINTMENTS_LIST'));
    try {
        yield call(appointmentService.appointmentRepeatService, action.payload.body);
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put(httpRequestsOnSuccessActions.appendSuccess(action.type));
        yield put(httpRequestsOnSuccessActions.appendSuccess('RENDER_APPOINTMENTS_LIST'));
    } catch (err) {
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put(httpRequestsOnErrorsActions.appendError(action.type, err?.data?.message));
    }
}

/** end */

function* appendSignatureToAppmt(action) {
    yield put(httpRequestsOnLoadActions.appendLoading(action.type, { type: action.payload?.type }));
    yield put(httpRequestsOnErrorsActions.removeError(action.type));
    yield put(httpRequestsOnSuccessActions.removeSuccess(action.type));
    try {
        yield call(appointmentService.appendSignatureTService, action.payload.id, action.payload.signature);

        const data = yield call(getAppointmentWithSessionIfAllowed, action?.payload?.id);
        yield put({
            type: GET_APPOINTMENT_BY_ID_SUCCESS,
            payload: data,
        });
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));

        // const res = yield call(appointmentService.getAppointmentByIdService, action?.payload?.id);
        // yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        // yield put({
        //     type: GET_APPOINTMENT_BY_ID_SUCCESS,
        //     payload: res.data,
        // });
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put(httpRequestsOnSuccessActions.appendSuccess(action.type, { type: action.payload?.type }));
    } catch (err) {
        toast(<NotError type={'error'} errMessage={err?.data?.message} />);
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put(httpRequestsOnErrorsActions.appendError(action.type, err?.data?.message));
    }
}

function* bulkAssignSignature(action) {
    yield put(httpRequestsOnLoadActions.appendLoading(action.type));
    yield put(httpRequestsOnErrorsActions.removeError(action.type));
    yield put(httpRequestsOnSuccessActions.removeSuccess(action.type));
    yield put(httpRequestsOnSuccessActions.removeSuccess('RENDER_APPOINTMENTS_LIST'));
    try {
        yield call(appointmentService.bulkAssignSignatureService, action?.payload?.body);
        // yield call(appointmentService.bulkAssignSignatureService, action.payload);
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put(httpRequestsOnSuccessActions.appendSuccess(action.type));
        yield put(httpRequestsOnSuccessActions.appendSuccess('RENDER_APPOINTMENTS_LIST'));
    } catch (err) {
        toast(<NotError type={'error'} errMessage={err?.data?.message} />);
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put(httpRequestsOnErrorsActions.appendError(action.type, err?.data?.message));
    }
}

function* deleteSignature(action) {
    yield put(httpRequestsOnLoadActions.appendLoading(action.type));
    yield put(httpRequestsOnErrorsActions.removeError(action.type));
    yield put(httpRequestsOnSuccessActions.removeSuccess(action.type));
    try {
        yield call(appointmentService.deleteSignatureService, action?.payload?.apptId, action?.payload?.type);

        const data = yield call(getAppointmentWithSessionIfAllowed, action?.payload?.apptId);
        yield put({
            type: GET_APPOINTMENT_BY_ID_SUCCESS,
            payload: data,
        });

        // const res = yield call(appointmentService.getAppointmentByIdService, action?.payload?.apptId);
        // yield put({
        //     type: GET_APPOINTMENT_BY_ID_SUCCESS,
        //     payload: res.data,
        // });
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put(httpRequestsOnSuccessActions.appendSuccess(action.type));
    } catch (err) {
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put(httpRequestsOnErrorsActions.appendError(action.type, err?.data?.message));
    }
}

function* getClientStaffs(action) {
    yield put(httpRequestsOnLoadActions.appendLoading(action.type));
    yield put(httpRequestsOnErrorsActions.removeError(action.type));
    yield put(httpRequestsOnSuccessActions.removeSuccess(action.type));
    try {
        const res = yield call(appointmentService.getClientStaffsService, action?.payload);
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        // yield put(httpRequestsOnSuccessActions.appendSuccess(action.type));
        yield put({
            type: GET_CLIENT_STAFFS_SUCCESS,
            payload: res?.data,
        });
    } catch (err) {
        yield put({
            type: GET_CLIENT_STAFFS_SUCCESS,
            payload: [],
        });
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put(httpRequestsOnErrorsActions.appendError(action.type, err?.data?.message));
    }
}

function* manageNotes(action) {
    yield put(httpRequestsOnLoadActions.appendLoading(action.type));
    yield put(httpRequestsOnErrorsActions.removeError(action.type));
    yield put(httpRequestsOnSuccessActions.removeSuccess(action.type));
    yield put(httpRequestsOnSuccessActions.removeSuccess('RENDER_APPOINTMENTS_LIST'));
    try {
        const res = yield call(appointmentService.manageNotesService, action.payload.id, action.payload.params);
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put(httpRequestsOnSuccessActions.appendSuccess(action.type));
        yield put(httpRequestsOnSuccessActions.appendSuccess('RENDER_APPOINTMENTS_LIST'));
        yield put({
            type: GET_APPOINTMENT_BY_ID,
            payload: { id: action.payload.id },
        });
    } catch (err) {
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put(httpRequestsOnErrorsActions.appendError(action.type, err?.data?.message));
    }
}

function* connectReconnect(action) {
    yield put(httpRequestsOnLoadActions.appendLoading(action.type));
    yield put(httpRequestsOnErrorsActions.removeError(action.type));
    yield put(httpRequestsOnSuccessActions.removeSuccess(action.type));
    yield put(httpRequestsOnSuccessActions.removeSuccess('RENDER_APPOINTMENTS_LIST'));
    try {
        yield call(appointmentService.connectReconnectService, action?.payload?.id, action?.payload?.params);
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put(httpRequestsOnSuccessActions.appendSuccess(action.type));
        yield put(httpRequestsOnSuccessActions.appendSuccess('RENDER_APPOINTMENTS_LIST'));

        if (action?.payload?.id) {
            const data = yield call(getAppointmentWithSessionIfAllowed, action?.payload?.id);
            yield put({
                type: GET_APPOINTMENT_BY_ID_SUCCESS,
                payload: data,
            });

            // const res = yield call(appointmentService.getAppointmentByIdService, action?.payload?.id);
            // yield put(httpRequestsOnLoadActions.removeLoading(action.type));
            // yield put({
            //     type: GET_APPOINTMENT_BY_ID_SUCCESS,
            //     payload: res.data,
            // });
        }
    } catch (err) {
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put(httpRequestsOnErrorsActions.appendError(action.type, err?.data?.message));
    }
}

function* cancelAppt(action) {
    yield put(httpRequestsOnLoadActions.appendLoading(action.type));
    yield put(httpRequestsOnErrorsActions.removeError(action.type));
    yield put(httpRequestsOnSuccessActions.removeSuccess(action.type));
    yield put(httpRequestsOnSuccessActions.removeSuccess('RENDER_APPOINTMENTS_LIST'));
    try {
        yield call(appointmentService.cancelApptService, action?.payload?.id, action?.payload?.params);
        yield put(httpRequestsOnSuccessActions.appendSuccess(action.type));
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put(httpRequestsOnSuccessActions.appendSuccess('RENDER_APPOINTMENTS_LIST'));
    } catch (err) {
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put(httpRequestsOnErrorsActions.appendError(action.type, err?.data?.message));
    }
}

function* unCancelAppt(action) {
    yield put(httpRequestsOnLoadActions.appendLoading(action.type));
    yield put(httpRequestsOnErrorsActions.removeError(action.type));
    yield put(httpRequestsOnSuccessActions.removeSuccess(action.type));
    yield put(httpRequestsOnSuccessActions.removeSuccess('RENDER_APPOINTMENTS_LIST'));
    try {
        yield call(appointmentService.unCancelApptService, action?.payload?.id);

        const data = yield call(getAppointmentWithSessionIfAllowed, action?.payload?.id);
        yield put({
            type: GET_APPOINTMENT_BY_ID_SUCCESS,
            payload: data,
        });

        // const res = yield call(appointmentService.getAppointmentByIdService, action?.payload?.id);
        // yield put({
        //     type: GET_APPOINTMENT_BY_ID_SUCCESS,
        //     payload: res.data,
        // });
        yield put(httpRequestsOnSuccessActions.appendSuccess(action.type));
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put(httpRequestsOnSuccessActions.appendSuccess('RENDER_APPOINTMENTS_LIST'));
    } catch (err) {
        toast(<NotError type="error" errMessage={err?.data?.message} />);
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put(httpRequestsOnErrorsActions.appendError(action.type, err?.data?.message));
    }
}

function* deleteAllAppt(action) {
    yield put(httpRequestsOnLoadActions.appendLoading(action.type));
    yield put(httpRequestsOnErrorsActions.removeError(action.type));
    yield put(httpRequestsOnSuccessActions.removeSuccess(action.type));
    yield put(httpRequestsOnSuccessActions.removeSuccess('RENDER_APPOINTMENTS_LIST'));
    try {
        yield call(appointmentService.deleteAllApptService, action?.payload?.id, action?.payload?.params);
        yield put(httpRequestsOnSuccessActions.appendSuccess(action.type));
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put(httpRequestsOnSuccessActions.appendSuccess('RENDER_APPOINTMENTS_LIST'));
    } catch (err) {
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put(httpRequestsOnErrorsActions.appendError(action.type, err?.data?.message));
    }
}

function* getApptStaffs(action) {
    yield put(httpRequestsOnLoadActions.appendLoading(action.type));
    try {
        const res = yield call(appointmentService.getApptStaffsService);
        yield put({
            type: GET_APPT_STAFFS_SUCCESS,
            payload: res?.data,
        });
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
    } catch (err) {
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
    }
}

/** Claim Documents */
function* uploadApptDocument(action) {
    yield put(httpRequestsOnLoadActions.appendLoading(action.type));
    yield put(httpRequestsOnErrorsActions.removeError(action.type));
    yield put(httpRequestsOnSuccessActions.removeSuccess(action.type));
    try {
        yield call(appointmentService.uploadService, action.payload.file, action.payload.id);
        yield put({
            type: GET_APPT_DOCUMENT,
            payload: { id: action?.payload?.id, load: 'noLoad' },
        });
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put(httpRequestsOnSuccessActions.appendSuccess(action.type));
    } catch (err) {
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put(httpRequestsOnErrorsActions.appendError(action.type, err?.data?.message));
    }
}

function* editApptDocument(action) {
    yield put(httpRequestsOnLoadActions.appendLoading(action.type));
    yield put(httpRequestsOnErrorsActions.removeError(action.type));
    yield put(httpRequestsOnSuccessActions.removeSuccess(action.type));
    try {
        yield call(appointmentService.editService, action?.payload);
        yield put({
            type: GET_APPT_DOCUMENT,
            payload: { id: action?.payload?.id, load: 'noLoad' },
        });
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put(httpRequestsOnSuccessActions.appendSuccess(action.type));
    } catch (err) {
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put(httpRequestsOnErrorsActions.appendError(action.type, err?.data?.message));
    }
}

function* getApptDocument(action) {
    if (action?.payload?.load !== 'noLoad') {
        yield put(httpRequestsOnLoadActions.appendLoading(action.type));
    }
    yield put(httpRequestsOnErrorsActions.removeError(action.type));
    try {
        const res = yield call(appointmentService.getFilesService, action.payload.id);
        yield put({
            type: GET_APPT_DOCUMENT_SUCCESS,
            payload: res?.data,
        });
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
    } catch (err) {
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put(httpRequestsOnErrorsActions.appendError(action.type, err?.data?.message));
    }
}

function* deleteApptDocument(action) {
    yield put(httpRequestsOnLoadActions.appendLoading(action.type));
    yield put(httpRequestsOnErrorsActions.removeError(action.type));
    yield put(httpRequestsOnSuccessActions.removeSuccess(action.type));
    try {
        yield call(appointmentService.deleteFilesService, action.payload.apptId, action.payload.id);
        yield put({
            type: GET_APPT_DOCUMENT,
            payload: { id: action?.payload?.apptId, load: 'noLoad' },
        });
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put(httpRequestsOnSuccessActions.appendSuccess(action.type));
        yield put(httpRequestsOnSuccessActions.removeSuccess('MINI_LOAD'));
    } catch (err) {
        yield put(httpRequestsOnSuccessActions.removeSuccess('MINI_LOAD'));
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put(httpRequestsOnErrorsActions.appendError(action.type, err?.data?.message));
    }
}

/** End */

function* refreshErrors(action) {
    yield put(httpRequestsOnLoadActions.appendLoading(action.type));
    yield put(httpRequestsOnErrorsActions.removeError(action.type));
    yield put(httpRequestsOnSuccessActions.removeSuccess(action.type));
    yield put(httpRequestsOnSuccessActions.removeSuccess('RENDER_APPOINTMENTS_LIST'));
    try {
        yield call(appointmentService.refreshErrorsService, action?.payload?.id);

        const data = yield call(getAppointmentWithSessionIfAllowed, action?.payload?.id);
        yield put({
            type: GET_APPOINTMENT_BY_ID_SUCCESS,
            payload: data,
        });

        // const res = yield call(appointmentService.getAppointmentByIdService, action?.payload?.id);
        // yield put({
        //     type: GET_APPOINTMENT_BY_ID_SUCCESS,
        //     payload: res.data,
        // });
        yield put(httpRequestsOnSuccessActions.appendSuccess('RENDER_APPOINTMENTS_LIST'));
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put(httpRequestsOnSuccessActions.appendSuccess(action.type));
    } catch (err) {
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put(httpRequestsOnErrorsActions.appendError(action.type, err?.data?.message));
    }
}

function* addEditApptNote(action) {
    yield put(httpRequestsOnLoadActions.appendLoading(action.type));
    yield put(httpRequestsOnErrorsActions.removeError(action.type));
    yield put(httpRequestsOnSuccessActions.removeSuccess(action.type));
    yield put(httpRequestsOnSuccessActions.removeSuccess('RENDER_APPOINTMENTS_LIST'));

    try {
        yield call(appointmentService.addEditApptNoteService, action?.payload?.id, action?.payload?.body);

        const data = yield call(getAppointmentWithSessionIfAllowed, action?.payload?.id);
        yield put({
            type: GET_APPOINTMENT_BY_ID_SUCCESS,
            payload: data,
        });

        // const res = yield call(appointmentService.getAppointmentByIdService, action?.payload?.id);
        // yield put({
        //     type: GET_APPOINTMENT_BY_ID_SUCCESS,
        //     payload: res.data,
        // });
        yield put(httpRequestsOnSuccessActions.appendSuccess('RENDER_APPOINTMENTS_LIST'));
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put(httpRequestsOnSuccessActions.appendSuccess(action.type));
    } catch (err) {
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put(httpRequestsOnErrorsActions.appendError(action.type, err?.data?.message));
    }
}
function* deleteApptNote(action) {
    yield put(httpRequestsOnLoadActions.appendLoading(action.type));
    yield put(httpRequestsOnErrorsActions.removeError(action.type));
    yield put(httpRequestsOnSuccessActions.removeSuccess(action.type));
    yield put(httpRequestsOnSuccessActions.removeSuccess('RENDER_APPOINTMENTS_LIST'));
    try {
        yield call(appointmentService.deleteApptNoteService, action?.payload?.apptId, action?.payload?.noteId, action?.payload?.type);

        const data = yield call(getAppointmentWithSessionIfAllowed, action?.payload?.apptId);
        yield put({
            type: GET_APPOINTMENT_BY_ID_SUCCESS,
            payload: data,
        });

        // const res = yield call(appointmentService.getAppointmentByIdService, action?.payload?.apptId);
        // yield put({
        //     type: GET_APPOINTMENT_BY_ID_SUCCESS,
        //     payload: res.data,
        // });
        yield put(httpRequestsOnSuccessActions.appendSuccess('RENDER_APPOINTMENTS_LIST'));
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put(httpRequestsOnSuccessActions.appendSuccess(action.type));
    } catch (err) {
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put(httpRequestsOnErrorsActions.appendError(action.type, err?.data?.message));
    }
}
function* requestApptNote(action) {
    yield put(httpRequestsOnLoadActions.appendLoading(action.type));
    yield put(httpRequestsOnErrorsActions.removeError(action.type));
    yield put(httpRequestsOnSuccessActions.removeSuccess(action.type));
    if (action?.payload?.apptId && action?.payload?.single) {
        yield put(httpRequestsOnSuccessActions.removeSuccess('RENDER_APPOINTMENTS_LIST'));
    }
    try {
        yield call(appointmentService.requestApptNoteService, action?.payload?.apptId, action?.payload?.message);
        if (action?.payload?.apptId && action?.payload?.single) {
            const data = yield call(getAppointmentWithSessionIfAllowed, action?.payload?.apptId);
            yield put({
                type: GET_APPOINTMENT_BY_ID_SUCCESS,
                payload: data,
            });

            // const res = yield call(appointmentService.getAppointmentByIdService, action?.payload?.apptId);
            // yield put({
            //     type: GET_APPOINTMENT_BY_ID_SUCCESS,
            //     payload: res.data,
            // });
            yield put(httpRequestsOnSuccessActions.appendSuccess('RENDER_APPOINTMENTS_LIST'));
        }
        yield put(httpRequestsOnSuccessActions.appendSuccess(action.type));
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
    } catch (err) {
        yield put(httpRequestsOnSuccessActions.removeSuccess(action.type));
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put(httpRequestsOnErrorsActions.appendError(action.type, err?.data?.message));
    }
}
function* remindApptNote(action) {
    yield put(httpRequestsOnLoadActions.appendLoading(action.type));
    yield put(httpRequestsOnErrorsActions.removeError(action.type));
    yield put(httpRequestsOnSuccessActions.removeSuccess(action.type));
    try {
        yield call(appointmentService.remindApptNoteService, action?.payload?.apptId, action?.payload?.body);
        yield put(httpRequestsOnSuccessActions.appendSuccess(action.type));
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
    } catch (err) {
        yield put(httpRequestsOnSuccessActions.removeSuccess(action.type));
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put(httpRequestsOnErrorsActions.appendError(action.type, err?.data?.message));
    }
}
function* remindApptSignature(action) {
    yield put(httpRequestsOnLoadActions.appendLoading(action.type));
    yield put(httpRequestsOnErrorsActions.removeError(action.type));
    yield put(httpRequestsOnSuccessActions.removeSuccess(action.type));
    try {
        yield call(appointmentService.remindApptSignatureService, action?.payload?.body);
        if (action?.payload?.apptId) {
            const data = yield call(getAppointmentWithSessionIfAllowed, action?.payload?.apptId);
            yield put({
                type: GET_APPOINTMENT_BY_ID_SUCCESS,
                payload: data,
            });
        }
        yield put(httpRequestsOnSuccessActions.appendSuccess(action.type));
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
    } catch (err) {
        yield put(httpRequestsOnSuccessActions.removeSuccess(action.type));
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put(httpRequestsOnErrorsActions.appendError(action.type, err?.data?.message));
    }
}

/** Eligibility */
function* checkEligibility(action) {
    yield put(httpRequestsOnLoadActions.appendLoading(action.type));
    yield put(httpRequestsOnErrorsActions.removeError(action.type));
    yield put(httpRequestsOnSuccessActions.removeSuccess(action.type));
    yield put(httpRequestsOnSuccessActions.removeSuccess('RENDER_APPOINTMENTS_LIST'));
    try {
        yield call(appointmentService.checkEligibilityService, action?.payload?.id);
        if (action?.payload?.apptId) {
            const data = yield call(getAppointmentWithSessionIfAllowed, action?.payload?.apptId);
            yield put({
                type: GET_APPOINTMENT_BY_ID_SUCCESS,
                payload: data,
            });

            // const res = yield call(appointmentService.getAppointmentByIdService, action?.payload?.apptId);
            // yield put({
            //     type: GET_APPOINTMENT_BY_ID_SUCCESS,
            //     payload: res.data,
            // });
        }
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put(httpRequestsOnSuccessActions.appendSuccess('RENDER_APPOINTMENTS_LIST'));
        yield put(httpRequestsOnSuccessActions.appendSuccess(action.type));
    } catch (err) {
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put(httpRequestsOnSuccessActions.removeSuccess(action.type));
        toast(<NotError type={'error'} errMessage={err?.data?.message} />);
    }
}

export const watchAppointments = function* watchAppointmentsSaga() {
    /** Create, Edit Appointment */
    yield takeLatest(CREATE_APPOINTMENT, createAppointmentSaga);
    yield takeLatest(EDIT_APPOINTMENT, editAppointmentSaga);
    yield takeLatest(ADD_APPOINTMENT_LINK, addAppointmentLink);
    yield takeLatest(CHANGE_APPOINTMENT_LOCK_UNLOCK, editApptLockUnlock);
    yield takeLatest(CHANGE_APPT_UNITS, changeApptUnits);
    /** end */

    /** Get Appointment */
    yield takeLatest(GET_APPOINTMENT, getAppointmentSaga);
    yield takeLatest(GET_APPOINTMENT_FOR_CALENDAR, getCalendarAppointmentSaga);
    yield takeLatest(GET_APPOINTMENT_BY_ID, getAppointmentByIdSaga);
    yield takeLatest(GET_APPOINTMENT_DATES_BY_ID, getAppointmentDatesByIdSaga);
    yield takeLatest(GET_APPOINTMENT_INFORMATION, getAppointmentInformation);
    yield takeLatest(GET_APPOINTMENT_BY_FILTERS, getAppointmentFilterSaga);
    yield takeLatest(GET_APPT_DATA_COLLECTION, getApptDataCollection);
    /** end */

    /** Delete Appointment */
    yield takeLatest(DELETE_APPOINTMENT, deleteAppointmentSaga);
    yield takeLatest(DELETE_MASS_APPTS, deleteMassAppointment);

    /** end */

    /** Appointment Status */
    yield takeLatest(SET_APPOINTMENT_STATUS, setAppointmentStatusSaga);
    yield takeLatest(REMOVE_APPT_FROM_BILL, removeApptFromBill);
    yield takeLatest(REMOVE_APPT_FROM_INVOICE, removeApptFromInvoice);
    yield takeLatest(UN_RENDER_APPT, unRenderAppt);
    yield takeLatest(CHANGE_CANCEL_REASON, changeCancelReason);
    yield takeLatest(COMPLETE_MASS_APPTS, completeMassAppts);
    /** end */

    /** Appointment Repeat */
    yield takeLatest(APPOINTMENT_REPEAT, appointmentRepeatSaga);
    yield takeLatest(APPOINTMENT_FROM_TEMPLATE, appointmentFromTemplateSaga);
    /** end */

    yield takeLatest(APPEND_SIGNATURE_TO_APPMT, appendSignatureToAppmt);
    yield takeLatest(BULK_ASSIGN_SIGNATURE, bulkAssignSignature);
    yield takeLatest(DELETE_SIGNATURE, deleteSignature);
    yield takeLatest(GET_CLIENT_STAFFS, getClientStaffs);
    yield takeLatest(MANAGE_NOTES, manageNotes);
    yield takeLatest(CONNECT_RECONNECT_TEMPLATE, connectReconnect);
    yield takeLatest(CANCEL_APPT, cancelAppt);
    yield takeLatest(UN_CANCEL_APPT, unCancelAppt);
    yield takeLatest(DELETE_ALL_APPT, deleteAllAppt);

    yield takeLatest(GET_APPT_STAFFS, getApptStaffs);

    /** Appt Documents */
    yield takeLatest(UPLOAD_APPT_DOCUMENT, uploadApptDocument);
    yield takeLatest(EDIT_APPT_DOCUMENT, editApptDocument);
    yield takeLatest(GET_APPT_DOCUMENT, getApptDocument);
    yield takeLatest(DELETE_APPT_DOCUMENT, deleteApptDocument);
    /** End */
    yield takeLatest(REFRESH_ERRORS, refreshErrors);
    yield takeLatest(ADD_EDIT_APPT_NOTE, addEditApptNote);
    yield takeLatest(DELETE_APPT_NOTE, deleteApptNote);
    yield takeLatest(REQUEST_APPT_NOTE, requestApptNote);
    yield takeLatest(REMIND_APPT_NOTE, remindApptNote);
    yield takeLatest(REMIND_APPT_SIGNATURE, remindApptSignature);
    /** Eligibility */
    yield takeLatest(CHECK_ELIGIBILITY, checkEligibility);
    yield takeLatest(GET_APPT_ADDRESSES, getApptAddresses);
    yield takeLatest(GET_ELIGIBLE_CHARGE_RATES, getEligibleChargeRates);
};
